import { fetchAudioText } from "./generate_audio_text.jsx";
import { fetchAudioFile } from "./generate_audio_file.jsx";

export const fetchWholeAudio = async (params) => {
  const {
    audioData,
    defaultCampaigns,
    selectedCategory,
    campaignDescription,
    language,
    setEditableTextAudio,
    setAudioText,
    setCurrentBalance,
    setSpinning,
    setFetchAudioTextStatus = () => {},
    setAllUploadedAudios = () => {},
    getToken,
    configData,
    navigate,
    notify,
    marketingGoals,
    targetAudience,
    vibeAndTone,
    setUploadAudioID,
    setAudioUrl,
    onAudioGenerated,
    ChangeFetchAudioFileStatus = () => {},
    setFetchonlyAudioStatus = () => {},
  } = params;

  const generatedText = await fetchAudioText({
    audioData,
    defaultCampaigns,
    selectedCategory,
    campaignDescription,
    language,
    setEditableTextAudio,
    setAudioText,
    setCurrentBalance,
    setSpinning,
    setFetchAudioTextStatus,
    getToken,
    configData,
    navigate,
    notify,
  });

  if (!generatedText) {
    return false;
  }

  await fetchAudioFile({
    fetchText: generatedText,
    audioData,
    marketingGoals,
    targetAudience,
    vibeAndTone,
    setUploadAudioID,
    language,
    setAudioUrl,
    onAudioGenerated,
    setCurrentBalance,
    setAllUploadedAudios,
    setSpinning,
    ChangeFetchAudioFileStatus,
    setFetchonlyAudioStatus,
    getToken,
    configData,
    navigate,
    notify,
  });

  return true;
};